/**
 * Theme's main js file
 * May handle main logic
 */

(function($, d, w) {

    let _w = $(w);

    _w.on('zp-load', init);

    function init() {

        beforeLoadNewPage();
        initPicturefillBackground();
        initSkrollr();
        registerWhiteHeaderAreas();
        viewContactform();
        setLinkTooltip();
        hideContactformHoneypots();
        // fixedFixMail();

        let isProjectSite = $('html').hasClass('site-project');
        if (isProjectSite) {
            changeTopBarSize();
            $( window ).on( "resize", ( event )  => {
                changeTopBarSize();
            });
        }
        // $( window ).on( "scroll", ( event )  => {
        //     fixedFixMail();
        // });

        // takeWidthFromIntroductionBox();
        // $( window ).on( "resize", ( event )  => {
        //     takeWidthFromIntroductionBox();
        // });

    }

    function initPicturefillBackground () {

        let picturefillBackgroundSelector = $('.zp-picturefill-background');

        w.picturefillBackgroundOptions = {
            selector: "zp-picturefill-background",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50% 50%",
        };
        w.picturefillBackground();
        picturefillBackgroundSelector.addClass('picturefill-background-visible');

    }

    function initSkrollr () {

        if ($('#zp-page').find('.zp_parallax').length > 0) {
            if (typeof skrollr != 'undefined' && typeof skrollr.get() == 'undefined') {
                // console.log('ScrollR: main init!');
                skrollr.init({
                    smoothScrolling: true,
                    forceHeight: false,
                    mobileCheck: function mobileCheck() {
                        //hack - forces mobile version to be off
                        return false;
                    }
                });
            }
            else if (typeof skrollr != 'undefined') {
                // console.log('ScrollR: main refresh!');
                skrollr.get().refresh();
            }
        }
        else {
           console.log('ScrollR: No ScrollR!');
        }
    }

    function registerWhiteHeaderAreas () {

        let areasWithWhiteHeader = $('.white_header');


        if (areasWithWhiteHeader.length != 0) {

            headerWhitening();
            _w.on('scroll', () => {

                headerWhitening();

            });

        }

    }

    function headerWhitening () {

        let areasWithWhiteHeader = $('.white_header');
        let areaOffsets = [];
        let areaOffsetsAndHeight = [];
        let windowHeight = _w.height();
        let header = $('#zp-header');
        let fixMail = $('#zp-fix-mail');
        let burgerLines = $('.zp-burger-line');
        let fullscreenLines = $('.zp-fullscreen > div');
        let logo = $('.zp-logo');
        let logoBurger = $('.zp-logo-burger');
        let projectNav = $('.zp-project-nav-icon, .zp-project-nav-link-text');



        areasWithWhiteHeader.each(( index, area ) => {

            let _area = $(area);
            let areaOffset = (_area.offset().top);
            let areaOffsetAndHeight = (((_area.offset().top)+_area.height()));
            areaOffsets.push(areaOffset);
            areaOffsetsAndHeight.push(areaOffsetAndHeight);

        });

        let windowScrollPosition = _w.scrollTop();

        let viewTopOnWhiteArea = false;
        let viewTop2OnWhiteArea = false;
        let viewBottomOnWhiteArea = false;
        areasWithWhiteHeader.each(( index, area ) => {


            if (windowScrollPosition+45 >= areaOffsets[index] && windowScrollPosition+45 <= areaOffsetsAndHeight[index]) {
                // console.log(areaOffsets);
                // console.log(areaOffsetsAndHeight);
                viewTopOnWhiteArea = true;

            }

            if (windowScrollPosition+140 >= areaOffsets[index] && windowScrollPosition+140 <= areaOffsetsAndHeight[index]) {

                viewTop2OnWhiteArea = true;

            }

            if (windowScrollPosition+windowHeight-110 >= areaOffsets[index] && windowScrollPosition+windowHeight-110 <= areaOffsetsAndHeight[index]) {

                viewBottomOnWhiteArea = true;

            }

        });
        if (viewTopOnWhiteArea) {

            burgerLines.addClass('is-white');
            fullscreenLines.addClass('is-white');
            logo.addClass('is-white');
            logoBurger.addClass('is-white');

        }
        else {

            burgerLines.removeClass('is-white');
            fullscreenLines.removeClass('is-white');
            logo.removeClass('is-white');
            logoBurger.removeClass('is-white');

        }

        if (viewTop2OnWhiteArea) {

            projectNav.addClass('is-white');

        }
        else {

            projectNav.removeClass('is-white');

        }

        if (viewBottomOnWhiteArea) {

            fixMail.addClass('is-white');

        }
        else {

            fixMail.removeClass('is-white');

        }

    }

    /**
     * Wenn Bildschirmbreite 768px beträgt: Ermittelt die Breite der Einleitung (steht i.d.R. ganz oben auf einer Seite)
     * und passt die Breite des Elementes, dass die Klasse "align-on-indroduction" besitzt, an, damit dieses Element an
     * den Einleitungstext ausgerichtet werden kann.
     * Man benötigt ein äuseres und ein inneres Element. Am besten verwendet man das Text-Element und gibt dem Element die
     * Klasse "align-on-introduction".
     * Die Einleitung muss die Klasse "zp-indroduction" enthalten
     */
    // function takeWidthFromIntroductionBox () {
    //
    //     let introduction = $('.zp-introduction > *:first-child');
    //     let introductionWidth = introduction.width();
    //     let elements = $('.align-on-introduction > *:first-child');
    //
    //     if (window.innerWidth <= 768) {
    //
    //         elements.each((index, element) => {
    //             let _element = $(element);
    //             _element.width(introductionWidth);
    //         });
    //
    //     }
    //     else {
    //
    //         elements.each((index, element) => {
    //             let _element = $(element);
    //             _element.width('initial');
    //         });
    //
    //     }
    //
    // }

    function fixedFixMail () {

        let fixMail = $('#zp-fix-mail');
        let fixMailContainer = $('#zp-fix-mail-container');

        let windowScrollPosition = _w.scrollTop();
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;
        let breakpointWidthProject = 769;
        let breakpointHeightProject = 680;
        let breakpointHeightNormal = 200;
        let isProjectSite = $('html').hasClass('site-project');


        // //Bei Projektseiten
        if (isProjectSite) {
            //Mache nur etwas, wenn Window < 680
            // if (windowHeight < breakpointHeightProject) {
            //
            //         if (breakpointHeightNormal > windowHeight-windowScrollPosition) {
            //             console.log('BOOM');
            //             fixMail.addClass('fixed');
            //             fixMail.removeClass('absolute');
            //             fixMail.addClass('top-normal');
            //             fixMail.removeClass('top-project');
            //             fixMailContainer.addClass('fixed');
            //             fixMailContainer.addClass('top-project');
            //         }
            //         else {
            //             fixMail.addClass('absolute');
            //             fixMail.removeClass('fixed');
            //             fixMail.removeClass('top-normal');
            //             fixMail.removeClass('top-project');
            //             fixMailContainer.removeClass('fixed');
            //             fixMailContainer.removeClass('top-project');
            //
            //         }
            //
            // }



            // if (windowWidth > breakpointWidthProject && windowHeight > breakpointHeightProject) {
            //     if(breakpointHeightProject > windowHeight-windowScrollPosition) {
            //         console.log('JO');
            //         console.log('BOOM');
            //         fixMail.addClass('fixed');
            //         fixMail.removeClass('absolute');
            //         fixMail.removeClass('top-normal');
            //         fixMail.addClass('top-project');
            //     }
            //     else {
            //         fixMail.addClass('absolute');
            //         fixMail.removeClass('fixed');
            //         fixMail.removeClass('top-project');
            //         fixMail.removeClass('top-normal');
            //     }
            // }
            // else {
            //     if (breakpointHeightNormal > windowHeight-windowScrollPosition) {
            //         console.log('BOOM');
            //         fixMail.addClass('fixed');
            //         fixMail.removeClass('absolute');
            //         fixMail.addClass('top-normal');
            //         fixMail.removeClass('top-project');
            //     }
            //     else {
            //         fixMail.addClass('absolute');
            //         fixMail.removeClass('fixed');
            //         fixMail.removeClass('top-normal');
            //         fixMail.removeClass('top-project');
            //     }
            // }
        }
        else {
            // console.log(breakpointHeightNormal, windowHeight-windowScrollPosition);
            if (breakpointHeightNormal > windowHeight-windowScrollPosition) {
                fixMailContainer.addClass('fixed');
                fixMailContainer.removeClass('absolute');
                fixMailContainer.addClass('top-normal');
            }
            else {
                fixMailContainer.addClass('absolute');
                fixMailContainer.removeClass('fixed');
                fixMailContainer.removeClass('top-normal');
            }
        }

    }

    function viewContactform () {

        let html = $('html');
        let fixMail = $('#zp-fix-mail, .zp-view-contactform');
        let contactform = $('#zp-contactform');
        let closeButtonAndBackground = $('#zp-contactform_close, #zp-contactform_veil');
        // let form = $('wpcf7-form');

        fixMail.on('click', () => {

            contactform.removeClass('hidden');
            html.addClass('overflow-hidden');

        });

        closeButtonAndBackground.on('click', () => {

            contactform.addClass('hidden');
            html.removeClass('overflow-hidden');

        });


    }


    function changeTopBarSize () {

        let top = $('#zp-project-top');
        let topBar = $('#zp-project-top-bar');
        let textarea = $('#zp-project-textarea');
        let topBarHeight = topBar.height();
        let textareaHeight = textarea.height();

        let windowWidth = window.innerWidth;
        let breakpoint1024 = 1024;
        let breakpoint768 = 768;
        let breakpoint480 = 480;

// console.log(textareaHeight,topBarHeight-325);

        if (windowWidth > breakpoint1024) {

            if (textareaHeight > topBarHeight - 424) {
                topBar.height(800 + (textareaHeight - 180));
                topBar.css('bottom', -400 - (textareaHeight - 180) + 'px');
                top.css('margin-bottom', textareaHeight - 180 + 'px');
            } else {

                topBar.height(800);
                topBar.css('bottom', -400 + 'px');
                top.css('margin-bottom', 0);

                topBarHeight = topBar.height();
                if (textareaHeight >= topBarHeight - 424) {
                    topBar.height(800 + (textareaHeight - 180));
                    topBar.css('bottom', -400 - (textareaHeight - 180) + 'px');
                    top.css('margin-bottom', textareaHeight - 180 + 'px');
                }
            }
        } else if (windowWidth > breakpoint768) {

            if (textareaHeight >= topBarHeight - 424) {
                topBar.height(800 + (textareaHeight - 180));
                topBar.css('bottom', -480 - (textareaHeight - 180) + 'px');
                top.css('margin-bottom', textareaHeight - 180 + 'px');
            } else {

                topBar.height(800);
                topBar.css('bottom', -480 + 'px');
                top.css('margin-bottom', 0);

                topBarHeight = topBar.height();
                if (textareaHeight >= topBarHeight - 424) {
                    topBar.height(800 + (textareaHeight - 180));
                    topBar.css('bottom', -480 - (textareaHeight - 180) + 'px');
                    top.css('margin-bottom', textareaHeight - 180 + 'px');
                }
            }
        }

        // else if (windowWidth >= breakpoint480) {
        //
        //     if (textareaHeight >= topBarHeight-335) {
        //         topBar.height(630+(textareaHeight-275));
        //         topBar.css('bottom', (-300-(textareaHeight-275))+'px');
        //         top.css('margin-bottom', (textareaHeight-275)+'px');
        //     }
        //     else {
        //
        //         topBar.height(630);
        //         topBar.css('bottom', -300+'px');
        //         top.css('margin-bottom', 0);
        //
        //         topBarHeight = topBar.height();
        //         if (textareaHeight >= topBarHeight-335) {
        //             topBar.height(630+(textareaHeight-275));
        //             topBar.css('bottom', (-300-(textareaHeight-275))+'px');
        //             top.css('margin-bottom', (textareaHeight-275)+'px');
        //         }
        //
        //     }
        //
        // }

        else {

            if (textareaHeight > topBarHeight-335) {
                topBar.height(630+(textareaHeight-275));
                topBar.css('bottom', (-350-(textareaHeight-275))+'px');
                top.css('margin-bottom', (textareaHeight-275)+'px');
            }
            else {

                topBar.height(630);
                topBar.css('bottom', -350+'px');
                top.css('margin-bottom', 0);

                topBarHeight = topBar.height();
                if (textareaHeight >= topBarHeight-335) {
                    topBar.height(630+(textareaHeight-275));
                    topBar.css('bottom', (-350-(textareaHeight-275))+'px');
                    top.css('margin-bottom', (textareaHeight-275)+'px');
                }

            }

        }

    }

    function beforeLoadNewPage () {

        window.onbeforeunload = function (event) {


            let href = event.target.activeElement.href;
            // console.log(href);
            if (typeof href === "undefined") {
                href = 'undefined';
            }
            if (href.includes('mailto:') || href.includes('.vcf') || href.includes('.pdf')) {

            }
            else {
                let scrollTop = _w.scrollTop();
                let html = $('html');

                html.css('opacity', 0);
                html.css('transform','translateY(-'+scrollTop+'px)');
                window.scrollTo(0,0);
            }

        };

    }

    function setLinkTooltip () {

        let linksWithTooltip = $('.zp-page a[zp-title]');
        let imgsWithTooltip = $('.zp-page *[data-tooltip]');

        linksWithTooltip.each((index, link) => {

            let _link = $(link);
            if (!_link.hasClass('no-tooltip')) {

                let linkTitle = _link.attr('zp-title');

                if (linkTitle.length) {
                    console.log(linkTitle);
                    _link.wrap('<span class="zp-link-with-tooltip"></span>');
                    _link.after( '<span class="zp-tooltip"><span class="zp-tooltip-inner">'+linkTitle+'</span></span>');
                }

            }


        });

        imgsWithTooltip.each((index, img) => {

            let _img = $(img);
            let imgTooltip = _img.attr('data-tooltip');

            if (imgTooltip.length) {
                _img.addClass('zp-img-with-tooltip');
                $('html').append( '<div class="zp-img-tooltip zp-img-tooltip-'+index+'"><div class="zp-tooltip-inner">'+imgTooltip+'</div></div>');


                let tooltip = $('.zp-img-tooltip-'+index);
                _img.on('mousemove',function (event) {

                    tooltip.addClass('visible');

                    var dot, eventDoc, doc, body, pageX, pageY;

                    event = event || window.event; // IE-ism

                    // If pageX/Y aren't available and clientX/Y are,
                    // calculate pageX/Y - logic taken from jQuery.
                    // (This is to support old IE)
                    if (event.pageX == null && event.clientX != null) {
                        eventDoc = (event.target && event.target.ownerDocument) || document;
                        doc = eventDoc.documentElement;
                        body = eventDoc.body;

                        event.pageX = event.clientX +
                            (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
                            (doc && doc.clientLeft || body && body.clientLeft || 0);
                        event.pageY = event.clientY +
                            (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
                            (doc && doc.clientTop  || body && body.clientTop  || 0 );
                    }
console.log(event.clientX, _w.width()-(tooltip.width() / 2));
                    if (event.pageX <= tooltip.width() / 2) {
                        console.log(1);
                        tooltip.css('left',event.pageX+10);
                    }
                    else if (event.pageX >= window.innerWidth-(tooltip.width() / 2) - 15) {
                        console.log(2);
                        tooltip.css('left', event.pageX-(tooltip.width()+30));
                    }
                    else {
                        console.log(3);
                        tooltip.css('left', event.pageX - (tooltip.width() / 2));
                    }

                    tooltip.css('top',event.pageY+(tooltip.height())-5);
                    // Use event.pageX / event.pageY here

                });
                _img.mouseleave(function (event) {

                    tooltip.removeClass('visible');

                });
            }


        });

    }

    function hideContactformHoneypots() {

        setTimeout(() => {

            $('#zp-contactform input.website').css({
                position: 'absolute',
                top: '-100vh'
            });

            $('#zp-contactform input.facebook').css({
                position: 'absolute',
                zIndex: '-1'
            });

            $('#zp-contactform input.twitter').css('display','none');


        }, 1234);

    }

}(jQuery, document, window));